// 1. constants
  // 1.1 colors
  // 1.2 box shadow
  // 1.5 space
  // 1.6 z-index
  // 1.7 breakpoints
  // 1.8 chart colors

import { getMobileAppParams } from '../mobile-app/mobileAppHandlers';
import { Theme } from '../styles/styles';
import { ProductCode } from 'funds-model';
import { ThemeColorsModel } from './tools/theme.model';

const hexToRgbA = (hex: string, opacity = 1) => {
  let c;
  if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
    c= hex.substring(1).split('');
    if(c.length === 3){
        c= [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c= `0x${c.join('')}`;
    return `rgba(${[(Number(c)>>16)&255, (Number(c)>>8)&255, Number(c)&255].join(',')},${opacity})`;
  }
  throw new Error('Bad Hex');
};

export const ColorsPaletteLight: ThemeColorsModel = {
  oranges: {
    10: '#FFECE0',
    50: '#FF6200',
    100: '#EB5A00',
    150: '#D65200',
  },
  blues: {
    10: '#E4F5FF',
    50: '#BEE8FE',
    100: '#89D6FD',
    150: '#185A7B',
  },
  violets: {
    10: '#F1E9FF',
    50: '#B487FF',
    100: '#7724FF',
    150: '#3C1280',
  },
  maroons: {
    10: '#FBE6F5',
    50: '#FF9FC7',
    100: '#4D0020',
    150: '#340016',
  },
  greys: {
    0: '#FFFFFF',
    10: '#F7F4F1',
    15: '#F1EDE9',
    20: '#DDD6CF',
    30: '#A69F98',
    40: '#6C6763',
    50: '#403B3B',
    60: '#302C2C',
    70: '#201E1E',
    75: '#111010',
    80: '#0D0804',
    82: '#201C18',
    84: '#34302C',
  },
  yellows: {
    10: '#FFFCE5',
    50: '#FFEE73',
    100: '#FFE100',
    150: '#AA9600'
  },
  greens: {
    10: '#CDF4D8',
    50: '#65FF39',
    150: '#0F4400',
    100: '#1E8700',
  },
  reds: {
    10: '#FFCFBF',
    50: '#FF3D00',
    100: '#CE2323',
    150: '#671900',
  },
  raspberries: {
    10: '#FBE6F5',
    50: '#FF68D5',
    100: '#D40199',
    150: '#8F096A',
  },
  blushes: {
    10: '#FBE6F5',
    50: '#FABEFE',
    100: '#F689FD',
    150: '#BE08C9',
  },
  functional: {
    disabled: '#4C5B65',
    active: '#F7F9FC',
  },
  constants: {
    greys: {
      0: '#ffffff',
      60: '#302C2C',
      70: '#201E1E',
    }
  },
  charts: {
    chartColor1: '#89d6fd',
    chartColor2: '#FFE100',
    chartColor3: '#65FF39',
    chartColor4: '#f689FD',
    chartColor5: '#B487FF',
    chartColor6: '#185A7B',
    chartColor7: '#FF6200',
    chartColor8: '#1E8700',
    chartColor9: '#D40199',
    chartColor10: '#7724FF',
    chartColor11: '#FF68D5',
    chartColor12: '#FF3D00',
    chartColor13: '#0F4400',
    chartColor14: '#8F096A',
    chartColor15: '#340016',
    chartColor16: '#be08c9',
    chartColor17: '#CE2323',
    chartColor18: '#008080',
    chartColor19: '#4D0020',
    chartColor20: '#3C1280',
  }
}

export const ColorsPaletteDark: ThemeColorsModel = {
  oranges: {
    10: '#FFECE0',
    50: '#FF6200',
    100: '#EB5A00',
    150: '#D65200',
  },
  blues: {
    10: '#0A2033',
    50: '#185A7B',
    100: '#89D6FD',
    150: '#BEE8FE',
  },
  violets: {
    10: '#210E47',
    50: '#3C1280',
    100: '#7724FF',
    150: '#B487FF',
  },
  maroons: {
    10: '#330016',
    50: '#340016',
    100: '#4D0020',
    150: '#FF9FC7',
  },
  greys: {
    0: '#0D0804',
    10: '#201E1E',
    15: '#403B3B',
    20: '#DDD6CF',
    30: '#A69F98',
    40: '#6C6763',
    50: '#403B3B',
    60: '#DDD6CF',
    70: '#ffffff',
    75: '#111010',
    80: '#FFFFFF',
    82: '#EBEBEB',
    84: '#D6D6D6',
  },
  yellows: {
    10: '#33300F',
    50: '#AA9600',
    100: '#FFE100',
    150: '#FFEE73'
  },
  greens: {
    10: '#CDF4D8',
    50: '#65FF39',
    150: '#0F4400',
    100: '#65FF39',
  },
  reds: {
    10: '#FFCFBF',
    50: '#FF3D00',
    100: '#FF3D00',
    150: '#671900',
  },
  raspberries: {
    10: '#330F2B',
    50: '#8F096A',
    100: '#D40199',
    150: '#FF9FC7',
  },
  blushes: {
    10: '#310D40',
    50: '#BE08C9',
    100: '#F689FD',
    150: '#FABEFE',
  },
  functional: {
    disabled: '#4C5B65',
    active: '#F7F9FC',
  },
  constants: {
    greys: {
      0: '#ffffff',
      60: '#302C2C',
      70: '#201E1E',
    }
  },
  charts: {
    chartColor1: '#89d6fd',
    chartColor2: '#FFE100',
    chartColor3: '#65FF39',
    chartColor4: '#f689FD',
    chartColor5: '#B487FF',
    chartColor6: '#185A7B',
    chartColor7: '#FF6200',
    chartColor8: '#1E8700',
    chartColor9: '#D40199',
    chartColor10: '#7724FF',
    chartColor11: '#FF68D5',
    chartColor12: '#FF3D00',
    chartColor13: '#0F4400',
    chartColor14: '#8F096A',
    chartColor15: '#340016',
    chartColor16: '#be08c9',
    chartColor17: '#CE2323',
    chartColor18: '#008080',
    chartColor19: '#4D0020',
    chartColor20: '#3C1280',
  }
}

// 1.1 colors

// 1.2 box shadow
export const mainBoxShadow = '0px 4px 12px rgba(74, 94, 104, 0.04)';
export const smallBoxShadow = '0px 2px 8px rgba(107, 116, 125, 0.16)';
export const layerBoxShadow = '0px 0px 10px 0px rgba(0, 0, 0, 0.15)';
export const highChartLegendItemBoxShadow = '0 0 4px 0 rgba(13, 24, 38, 0.25)';
export const pressedLinkShadow = 'rgba(0, 0, 0, 0.08)';

export const interactiveLinkStyle = (theme: Theme) => ({
  textDecoration: 'underline',
  textDecorationColor: theme.color.violets[100],
  textDecorationThickness: 2,
  textDecorationSkipInk: 'auto',
});

// 1.2 box shadow - dark theme
export const mainBoxShadowDark = `0px 4px 12px ${hexToRgbA(ColorsPaletteLight.greys[80], 0.04)}`;
export const smallBoxShadowDark = `0px 2px 8px ${hexToRgbA(ColorsPaletteLight.greys[80], 0.16)}`;
export const highChartLegendItemBoxShadowDark = '0 0 4px 0 rgba(0, 0, 0, 0.45)';
export const cardBoxShadow = '0px 2px 8px 2px rgba(0, 0, 0, 0.16)';
export const cardBoxShadowDark = `0px 2px 8px 2px ${hexToRgbA(ColorsPaletteLight.greys[80], 0.16)}`;

// 1.2 box shadow - campaign modal
export const campaignModalBackdrop = hexToRgbA(ColorsPaletteLight.greys[80], 0.35);

// 1.5 space
export const space = {
  maxWidth: 1620,
  layoutMaxWidth: 1192,
  basicDataMaxWidth: 1032,
  fundDetailsBackgroundMaxWidth: 1920,
  fundDetailsMaxWidthDefault: 1256,
  bottomBarMaxWidth: 1370,
  allocationProcessMaxWidth: 1024,
  dataWizardContentMaxWidth: 856,
  singleColumnMaxWidth: 680,
  navWidth: 244,
  headerHeight: 97,
  headerMobileHeight: 64,
  navCollapseWidth: 56,
  appPadding: 16,
  mobileNavHeight: () => 64 + (getMobileAppParams()?.safeViewBottom ?? 0),
  mobileBottomPadding: () => (getMobileAppParams()?.safeViewBottom ?? 0),
  mobileTopPadding: () => (getMobileAppParams()?.safeViewTop ?? 0)
};

// 1.6 z-index
export const zIndex = {
  autocompleteDropdownZIndex: 1301,
  tooltipAppBarZIndexLow: 1003,
  tooltipAppBarZIndex: 1005,
  tooltipInModalZIndex: 1301,
  modalZIndex: 1005,
  menuModalZIndex: 1006,
  menuSubModalZIndex: 1007,
  fundCardHeaderZIndex: 1,
}

// 1.7 breakpoints
export const Breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  sl: 1080,
  lg: 1270,
  xl: 1536
};

// 1.8 chart colors
export const getFundColors = (theme: Theme) => {
  return [
    theme.color.charts.chartColor1,
    theme.color.charts.chartColor2,
    theme.color.charts.chartColor3,
    theme.color.charts.chartColor4,
    theme.color.charts.chartColor5,
    theme.color.charts.chartColor6,
    theme.color.charts.chartColor7,
    theme.color.charts.chartColor8,
    theme.color.charts.chartColor9,
    theme.color.charts.chartColor10,
    theme.color.charts.chartColor11,
    theme.color.charts.chartColor12,
    theme.color.charts.chartColor13,
    theme.color.charts.chartColor14,
    theme.color.charts.chartColor15,
    theme.color.charts.chartColor16,
    theme.color.charts.chartColor17,
    theme.color.charts.chartColor18,
    theme.color.charts.chartColor19,
    theme.color.charts.chartColor20,
  ];
};

export const getProductColors = (theme: Theme, isDarkTheme = false) => ({
  [ProductCode.basic]: theme.color.charts.chartColor5,
  [ProductCode.ike]: theme.color.charts.chartColor7,
  [ProductCode.ikze]: theme.color.charts.chartColor10,
  [ProductCode.ppi]: theme.color.charts.chartColor4,
  [ProductCode.ppe]: theme.color.charts.chartColor1,
  [ProductCode.ppk]: theme.color.charts.chartColor6,
  pension: theme.color.charts.chartColor2,
  investments: theme.color.charts.chartColor9
});

export const headerMobileHelperSpacer = `calc(${space.headerMobileHeight}px + 12px)`;
